
export const productFilters = [{ text: 'SKU', value: 'sku' }, { text: 'Product', value: 'name' }]

export const orderFilters = [
  { text: 'Company', value: 'company' },
  { text: 'Product', value: 'product.name' },
  { text: 'Request Id', value: 'req_id' }
]